import React from 'react';
import './SocialMediaLinks.scss';

interface SocialMediaLinksProps {
    facebook?: string;
    instagram?: string;
    youtube?: string;
}

const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({ 
    facebook, 
    instagram, 
    youtube 
}) => {
    // Only render if at least one social link is provided
    if (!facebook && !instagram && !youtube) {
        return null;
    }

    return (
        <div className="social-media-wrapper">
            {facebook && (
                <div className="item">
                    <a 
                        href={facebook} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="fb"
                        aria-label="Facebook"
                    ></a>
                </div>
            )}
            {instagram && (
                <div className="item">
                    <a 
                        href={instagram} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="ins"
                        aria-label="Instagram"
                    ></a>
                </div>
            )}
            {youtube && (
                <div className="item">
                    <a 
                        href={youtube} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="yt"
                        aria-label="YouTube"
                    ></a>
                </div>
            )}
        </div>
    );
};

export default SocialMediaLinks;
